import { ArrowLeft, Construction, type LucideIcon } from 'lucide-react';
import { EmptyState } from '../components/dashboard/EmptyState';
import type { ViewId } from '../components/layout/navigation';

type Props = {
  description: string;
  icon: LucideIcon;
  moduleName: string;
  onNavigate: (viewId: ViewId) => void;
};

export const ModuleView = ({ description, icon, moduleName, onNavigate }: Props) => (
  <div className="page-stack">
    <section className="intro-card">
      <p className="eyebrow">Clean workspace</p>
      <h2>{moduleName}</h2>
      <p>{description}</p>
    </section>
    <section className="module-card">
      <EmptyState
        description={`This workspace is reserved for the next approved feature phase. Your current planner data is unchanged.`}
        icon={icon ?? Construction}
        title={`No ${moduleName.toLowerCase()} yet`}
      />
      <button type="button" className="secondary-button module-back" onClick={() => onNavigate('home')}>
        <ArrowLeft size={18} aria-hidden="true" /> Back to Home
      </button>
    </section>
  </div>
);
